import { render, staticRenderFns } from "./mr_widget_container.vue?vue&type=template&id=aa3e0088&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "mr_widget_container.vue"
export default component.exports